import { FC } from 'react'

interface GridInSymbolsProps {
  children?: JSX.Element | JSX.Element[]
}

export const GridInSymbolsComponent: FC<GridInSymbolsProps> = ({ children }) => {
  return <>{children}</>
}
